import { Button, Form } from 'antd';
import styled from 'styled-components';

export const Footer = styled.div`
	padding-top: 0.6rem;
	justify-content: flex-end;
	display: flex;
	gap: 0.6rem;
`;

export const UserCreationFormItem = styled(Form.Item)`
	label {
		font-weight: 400 !important;
		font-size: 1rem !important;
		color: ${p => p.theme.text} !important;
	}
`;

export const UserCreationFormConfirmButton = styled(Button)`
	display: flex;
	align-items: center;
	justify-content: center;
	height: 45px;
	gap: 0.3rem;
	width: 100%;
	margin-top: 2rem;

	p {
		font-size: 18px;
		color: white;
		padding-bottom: 1px;
		margin: 0 auto;
	}

	&:disabled {
		background-color: ${p => p.theme.primaryOpacity};
		border-color: ${p => p.theme.primaryOpacity};
		p {
			color: ${p => p.theme.primary};
		}

		svg {
			color: ${p => p.theme.primary};
		}
	}
`;
